<template>
  <div class="flex space-x-1">
    <div class="flex-grow">
      <label for="document-type-selector" class="pb-2 block text-sm font-medium text-gray-700">Tipo</label>
      <a-select
        id="document-type-selector"
        :default-value="internalDocType"
        @change="onUpdateDocType"
        class="block w-full"
        placeholder="Selecciona un tipo de documento"
        show-search
        option-filter-prop="label"
      >
        <a-select-option v-for="(docType, index) in docTypes" :key="index" :value="docType.code">
          <span>{{ docType.name }}</span>
        </a-select-option>
      </a-select>
    </div>
    <div class="flex-grow">
      <label for="document-number" class="pb-2 block text-sm font-medium text-gray-700">Número</label>
      <a-input
        id="document-number"
        :value="internalDocNumber"
        @change="onUpdateDocNumber"
        placeholder="Ingresá el número de documento"
        class="block w-full"
      />
    </div>
  </div>
</template>

<script>
import { Select, Input } from 'ant-design-vue'

export default {
  components: {
    'a-select': Select,
    'a-select-option': Select.Option,
    'a-input': Input
  },
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    value: {
      type: Object,
      default: () => ({ docType: '', docNumber: '' })
    }
  },
  computed: {
    internalDocType () {
      return this.value.docType?.code || null
    },
    internalDocNumber () {
      return this.value.docNumber || ''
    }
  },
  data () {
    return {
      docTypes: [
        { code: 'dni', name: 'DNI' },
        { code: 'passport', name: 'Pasaporte' },
        { code: 'license', name: 'Licencia de Conducir' },
        { code: 'id', name: 'ID' }
        // Puedes añadir más tipos de documentos aquí
      ]
    }
  },
  methods: {
    onUpdateDocType (value) {
      const selectedDocType = this.docTypes.find(record => record.code === value)
      this.$emit('change', { ...this.value, docType: selectedDocType })
    },
    onUpdateDocNumber (event) {
      this.$emit('change', { ...this.value, docNumber: event.target.value })
    }
  }
}
</script>

<style scoped>
/* Puedes añadir estilos adicionales aquí si es necesario */
</style>
